const STYLESHEET_ELEMENT_CREATED_EVENT = "stylesheet-created";
const STYLESHEET_ELEMENT_TOGGLE_EVENT = "stylesheet-toggle";
const UPDATE_EVENT_PREFIX = `css-var-update-`;
export { STYLESHEET_ELEMENT_CREATED_EVENT, STYLESHEET_ELEMENT_TOGGLE_EVENT, UPDATE_EVENT_PREFIX };
